export default __webpack_public_path__ + "static/media/Swipe Guide.2f00afdb.png";